import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { ArrowLeftOnRectangleIcon, Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { NAV_GROUPS, MOBILE_PRIMARY_ITEMS } from './adminNavConfig';
import { useAuth } from '../../components/AuthContext';

// Barra inferior de móvil (patrón de app, no de sitio web) — 4 accesos de uso
// diario al alcance del pulgar + "Más", que abre el resto en un sheet que
// sube desde abajo agrupado igual que el sidebar de PC.
const AdminMobileNav = () => {
  const [moreOpen, setMoreOpen] = useState(false);
  const navigate = useNavigate();
  const { logout } = useAuth();
  const openMessaging = () => window.dispatchEvent(new Event('admin-messaging:toggle'));
  const handleLogout = async () => {
    await logout();
    setMoreOpen(false);
    navigate('/login', { replace: true });
  };

  return (
    <>
      <nav
        className="fixed inset-x-0 bottom-0 z-40 flex border-t border-gray-200 bg-white md:hidden"
        style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      >
        {MOBILE_PRIMARY_ITEMS.map((item) =>
          item.action === 'messaging' ? (
            <button
              key={item.name}
              type="button"
              onClick={openMessaging}
              className="flex flex-1 flex-col items-center gap-0.5 py-2 text-[11px] font-medium text-gray-500"
            >
              <item.icon className="h-5 w-5" />
              {item.name}
            </button>
          ) : (
            <NavLink
              key={item.name}
              to={item.to}
              className={({ isActive }) =>
                `flex flex-1 flex-col items-center gap-0.5 py-2 text-[11px] font-medium ${
                  isActive ? 'text-orange-600' : 'text-gray-500'
                }`
              }
            >
              <item.icon className="h-5 w-5" />
              {item.name}
            </NavLink>
          )
        )}
        <button
          type="button"
          onClick={() => setMoreOpen(true)}
          className="flex flex-1 flex-col items-center gap-0.5 py-2 text-[11px] font-medium text-gray-500"
        >
          <Bars3Icon className="h-5 w-5" />
          Más
        </button>
      </nav>

      {moreOpen && (
        <div className="fixed inset-0 z-50 md:hidden">
          <div className="absolute inset-0 bg-black/30" onClick={() => setMoreOpen(false)} />
          <div className="absolute inset-x-0 bottom-0 max-h-[75vh] overflow-y-auto rounded-t-2xl bg-white p-4 pb-8 shadow-2xl">
            <div className="mb-3 flex items-center justify-between">
              <h2 className="text-sm font-bold text-gray-700">Más opciones</h2>
              <button type="button" onClick={() => setMoreOpen(false)} aria-label="Cerrar">
                <XMarkIcon className="h-5 w-5 text-gray-400" />
              </button>
            </div>
            {NAV_GROUPS.map((group) => (
              <div key={group.label} className="mb-4">
                <p className="mb-1.5 text-[11px] font-bold uppercase tracking-wide text-gray-400">{group.label}</p>
                <ul className="grid grid-cols-2 gap-2">
                  {group.items.map(({ name, icon: Icon, to }) => (
                    <li key={name}>
                      <NavLink
                        to={to}
                        onClick={() => setMoreOpen(false)}
                        className="flex items-center gap-2 rounded-xl border border-gray-100 bg-gray-50 px-3 py-2.5 text-sm font-medium text-gray-700"
                      >
                        <Icon className="h-4 w-4 flex-shrink-0 text-orange-500" />
                        <span className="truncate">{name}</span>
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
            <button
              type="button"
              onClick={handleLogout}
              className="flex w-full items-center justify-center gap-2 rounded-xl border border-red-100 bg-red-50 px-3 py-3 text-sm font-semibold text-red-700"
            >
              <ArrowLeftOnRectangleIcon className="h-5 w-5" />
              Cerrar sesión
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default AdminMobileNav;
